import { useSelector } from 'react-redux'
import CloseWidgetBtn from 'app/components/CloseWidgetBtn'
import { truncateText } from 'app/utils/text'
import CoverLogo from 'app/components/CoverLogo'
import './header.scss'

const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

const Header = () => {
  const widgetInfo = useSelector(getWidgetInfo)
  // extract texts
  const languageInfo = useSelector(getLanguageInfo)

  const { direction = 'rtl' } = languageInfo.general || {}

  const headerTitle = widgetInfo.data.personalize.title
  const headerDescription = widgetInfo.data.personalize.title2

  return (
    <div className="sc_header_wrapper">
      <div className="sc_header">
        <div className="sc_header_team_name">
          <div className="sc_header_team__logo_container">
            <CoverLogo />
          </div>
          <div className="sc_header_title_desc_wrapper">
            <div title={headerTitle} className="sc_header_title">
              {truncateText(headerTitle, 60)}
            </div>
            <div>
              <p title={headerDescription} className="sc_header_description">
                {truncateText(headerDescription, 60)}
              </p>
            </div>
          </div>
        </div>
        {direction === 'rtl' && <CloseWidgetBtn />}
      </div>
    </div>
  )
}

export default Header
